/* eslint-disable */
import React from 'react';

const IconHeart = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
        <g>
            <g>
                <path
                    stroke="#053b80"
                    strokeMiterlimit="20"
                    strokeWidth="2"
                    d="M11.784 20.303c.066.04.141.057.216.057.075 0 .15-.018.216-.057C12.656 20.052 23 14.099 23 7.16A6.167 6.167 0 0 0 16.84 1c-1.91 0-3.674.871-4.84 2.358A6.123 6.123 0 0 0 7.16 1 6.167 6.167 0 0 0 1 7.16c0 6.939 10.344 12.892 10.784 13.143"/>
            </g>
        </g>
    </svg>
    // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
    // 	<path
    // 		d="M16.843 24.038a.303.303 0 00.157.042.303.303 0 00.157-.042c.32-.182 7.843-4.512 7.843-9.558 0-2.47-2.01-4.48-4.48-4.48A4.454 4.454 0 0017 11.715 4.453 4.453 0 0013.48 10C11.01 10 9 12.01 9 14.48c0 5.046 7.523 9.376 7.843 9.558"
    // 		strokeWidth="1.5"
    // 		fillRule="evenodd"
    // 	/>
    // </svg>
);

export default IconHeart;
